import { render, staticRenderFns } from "./DropMenuTreeView.vue?vue&type=template&id=84c9644a&scoped=true&"
import script from "./DropMenuTreeView.vue?vue&type=script&lang=js&"
export * from "./DropMenuTreeView.vue?vue&type=script&lang=js&"
import style0 from "./DropMenuTreeView.vue?vue&type=style&index=0&id=84c9644a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c9644a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VMenu,VTreeview})
